import styles from './MobileNav.module.css'
import { Link } from 'react-router-dom'
import { NEWS_PAGE, PROJECTS_PAGE, SUPPORT_PAGE } from '../../router/paths'
import Icon from '../Icon'
import cn from 'classnames'

export default function MobileNav() {
  return (
    <div className={styles.wrapper}>
        <Link className={styles.button} to={PROJECTS_PAGE}>
            <Icon name='homeIcon' width='16' height='16'></Icon>
            <span className={cn('text_subheaders_sh4', styles.link)}>Проекты</span>
        </Link>
        <Link className={styles.button} to={NEWS_PAGE}>
            <Icon name='newsIcon' width='16' height='16'></Icon>
            <span className={cn('text_subheaders_sh4', styles.link)}>Новости</span>
        </Link>
        <Link className={styles.button} to={SUPPORT_PAGE}>
            <Icon name='supportIcon' width='16' height='16'></Icon>
            <span className={cn('text_subheaders_sh4', styles.link)}>Поддержка</span>
        </Link>
    </div>
  )
}
